module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('privat-auth-blank-form', {
    attrs: {
      "submit-label": "Отправить",
      "user": _vm.user,
      "errors": _vm.errors
    },
    on: {
      "submit": _vm.processAuthForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8dc872cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/privat_auth/PrivatAuthForm.vue
// module id = 684
// module chunks = 0